/** MCQ / Tech session integrity tag catalog (mirrors backend v1). */
export const INTEGRITY_CATALOG_VERSION = 'v1';

export const INTEGRITY_DISPOSITIONS = [
  { value: 'clear', label: 'Clear' },
  { value: 'caution', label: 'Caution' },
  { value: 'concern', label: 'Concern' },
];

export const INTEGRITY_REVIEW_DEPTHS = [
  { value: 'watched_full', label: 'Watched fully' },
  { value: 'spot_checked', label: 'Spot-checked' },
  { value: 'recording_unavailable', label: 'Recording unavailable' },
];

export const INTEGRITY_SEVERITY_RANK = { clear: 0, caution: 1, concern: 2 };

/** @type {{ code: string, label: string, category: string, severity: 'clear'|'caution'|'concern' }[]} */
export const INTEGRITY_TAGS = [
  { code: 'face_visible_throughout', label: 'Face visible throughout', category: 'Presence', severity: 'clear' },
  { code: 'left_frame_briefly', label: 'Left frame briefly', category: 'Presence', severity: 'caution' },
  { code: 'absent_extended', label: 'Absent for extended period', category: 'Presence', severity: 'concern' },
  { code: 'looking_at_screen', label: 'Looking at screen mostly', category: 'Attention', severity: 'clear' },
  { code: 'frequent_look_away', label: 'Frequent look-away', category: 'Attention', severity: 'caution' },
  { code: 'sustained_off_screen', label: 'Sustained off-screen focus', category: 'Attention', severity: 'concern' },
  { code: 'quiet_alone', label: 'Quiet, alone', category: 'Environment', severity: 'clear' },
  { code: 'distracting_background', label: 'Distracting background activity', category: 'Environment', severity: 'caution' },
  { code: 'another_person_visible', label: 'Another person visible', category: 'Environment', severity: 'concern' },
  { code: 'no_notable_speech', label: 'No notable speech', category: 'Audio', severity: 'clear' },
  { code: 'background_noise', label: 'Background noise spikes', category: 'Audio', severity: 'caution' },
  { code: 'talking_whispering', label: 'Talking / whispering', category: 'Audio', severity: 'concern' },
  { code: 'no_secondary_device', label: 'No secondary device seen', category: 'Devices', severity: 'clear' },
  { code: 'phone_visible', label: 'Phone / second screen visible', category: 'Devices', severity: 'concern' },
  { code: 'session_looked_normal', label: 'SEB / session looked normal', category: 'Process', severity: 'clear' },
  { code: 'recording_incomplete', label: 'Recording incomplete / unusable', category: 'Process', severity: 'caution' },
  { code: 'suspected_external_help', label: 'Suspected external help', category: 'Process', severity: 'concern' },
];

export const INTEGRITY_CATEGORIES = [
  'Presence',
  'Attention',
  'Environment',
  'Audio',
  'Devices',
  'Process',
];

export const INTEGRITY_TAG_BY_CODE = Object.fromEntries(
  INTEGRITY_TAGS.map((t) => [t.code, t]),
);

export function suggestedDisposition(tagCodes = []) {
  let rank = 0;
  for (const code of tagCodes) {
    const tag = INTEGRITY_TAG_BY_CODE[code];
    if (!tag) continue;
    rank = Math.max(rank, INTEGRITY_SEVERITY_RANK[tag.severity] ?? 0);
  }
  if (rank >= 2) return 'concern';
  if (rank === 1) return 'caution';
  return 'clear';
}

export function formatIntegrityTime(tSec) {
  const s = Math.max(0, Math.floor(Number(tSec) || 0));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, '0')}`;
}

export function dispositionToneClass(disposition) {
  if (disposition === 'concern') return 'border-rose-200 bg-rose-50 text-rose-800';
  if (disposition === 'caution') return 'border-amber-200 bg-amber-50 text-amber-900';
  if (disposition === 'clear') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
  return 'border bg-secondary text-muted-foreground';
}

export function severityChipClass(severity) {
  if (severity === 'concern') return 'border-rose-200 bg-rose-50 text-rose-800';
  if (severity === 'caution') return 'border-amber-200 bg-amber-50 text-amber-900';
  return 'border-emerald-200 bg-emerald-50 text-emerald-800';
}
